import { Button, TableHead } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';
import formatDate from '../../Utils/dateFormatter';
import { TablePaginationActions } from './MissionsList';

export default function CustomPaginationActionsTable({ rows, handleClose }) {
    CustomPaginationActionsTable.propTypes = {
        rows: PropTypes.any,
        handleClose: PropTypes.func,
    };
    const [page, setPage] = React.useState(0);
    const { i18n } = useTranslation();
    const [rowsPerPage, setRowsPerPage] = React.useState(2);
    const { setMission } = useGlobalContext();

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const columns = [
        { id: 'title', label: 'Titre', minWidth: 160 },
        { id: 'status', label: 'Statut', minWidth: 160 },
        { id: 'createdAt', label: 'Date de creation', minWidth: 160 },
        { id: 'action', label: '', minWidth: 160 },
    ];
    const color = (status) => {
        switch (status) {
        case 'normal':
            return '#B7D8DC';

        case 'overdue':
            return '#F50000';

        case 'ahead of time':
            return '#F285BB';

        case 'risky':
            return '#FFCF00';

        default:
            return '#B7D8DC';
        }
    };
    return (
        <TableContainer component={Paper}>
            <Table
                sx={{ minWidth: 500 }}
                aria-label="custom pagination table"
            >
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(rowsPerPage > 0
                        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : rows
                    ).map((row) => (
                        <TableRow key={row.name}>
                            <TableCell align="start">{row?.titre}</TableCell>
                            <TableCell
                                style={{ width: 160 }}
                                align="start"
                            >
                                <span
                                    style={{
                                        backgroundColor: color(row.status),
                                        padding: '10px',
                                        color: '#232F49',
                                        borderRadius: '3px',
                                    }}
                                >
                                    {row.status}
                                </span>
                            </TableCell>
                            <TableCell
                                style={{ width: 160 }}
                                align="start"
                            >
                                {formatDate(row.createdAt)}
                            </TableCell>
                            <TableCell
                                style={{ width: 160 }}
                                align="start"
                            >
                                <form>
                                    <Button
                                        type="submit"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setMission(row);
                                            handleClose();
                                        }}
                                    >
                                        {i18n.t('Choisir')}
                                    </Button>
                                </form>
                            </TableCell>
                        </TableRow>
                    ))}
                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                        </TableRow>
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[]}
                            colSpan={3}
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                                inputProps: {
                                    'aria-label': 'rows per page',
                                },
                                native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
